import {useEffect} from "react";


const Sair = () => {
 
    useEffect(() => {
     // localStorage.clear();
        localStorage.removeItem('token-id');
        localStorage.removeItem('userId');
        localStorage.removeItem('username');
      window.location.href = '/';
    }, []);
    return <></>;
};

export default Sair;